import * as React from "react";
import { List, Image } from "@grandvisionhq/common";
import { Heading, Hr } from "@grandvisionhq/elements";
/* empty css             */
const Measure = ({
  measureDescription,
  measureDescriptionImage,
  measureImage,
  measureSteps,
  measureTitle
}) => {
  if (!measureTitle || !measureSteps || !measureImage || !measureDescriptionImage) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "measure" }, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", className: "measure__title" }, measureTitle), /* @__PURE__ */ React.createElement("div", { className: "measure__container" }, /* @__PURE__ */ React.createElement(List, { items: measureSteps, numerical: true }), /* @__PURE__ */ React.createElement(
    Image,
    {
      alt: measureImage.description || "",
      className: "measure__steps-image",
      url: measureImage.url
    }
  )), /* @__PURE__ */ React.createElement(Hr, null), /* @__PURE__ */ React.createElement("div", { className: "measure__container" }, /* @__PURE__ */ React.createElement("div", null, measureDescription), /* @__PURE__ */ React.createElement(
    Image,
    {
      alt: measureDescriptionImage.description || "",
      className: "measure__description-image",
      url: measureDescriptionImage.url
    }
  )));
};
export {
  Measure as default
};
//# sourceMappingURL=Measure.js.map
